import { render } from "./FormTesisY.vue?vue&type=template&id=e145e998&scoped=true"
import script from "./FormTesisY.vue?vue&type=script&lang=js"
export * from "./FormTesisY.vue?vue&type=script&lang=js"

import "./FormTesisY.vue?vue&type=style&index=0&id=e145e998&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e145e998"

export default script